<template>
  <div class="row aviso-cookies" v-show="mostrarFooter">
    <div class="col-lg-12 col-sm-12">
      <div class="w-100 aviso-cookies__contenedor-icono">
        <i class="fas fa-times aviso-cookies__icono" @click="CerrarFooter()"></i>
      </div>
      <p class="aviso-cookies__parrafo" v-if="idioma == 'ES'">
        “Este sitio utiliza cookies a través de las cuales es posible monitorear
        su comportamiento como usuario de Internet, al continuar navegando en
        él, estará aceptando su uso. Podrás deshabilitarlo accediendo a la
        configuración de tu navegador.
        <a
          class="link-bienvenida"
          data-bs-toggle="modal"
          data-bs-target="#modalTerminosAvisos"
        >
          <b>Aviso de Privacidad</b>”</a
        >.
      </p>
      <p class="aviso-cookies__parrafo" v-else>
        “This site uses cookies through which it is possible to monitor your
        Internet user behavior. monitor your behavior as an Internet user, by
        continuing to browse the by continuing to browse the site, you are
        agreeing to their use. You will be able to disable it by accessing your
        browser settings.
        <a
          style="cursor: pointer;"
          class="link-bienvenida"
          data-bs-toggle="modal"
          data-bs-target="#modalTerminosAvisos"
        >
          <b>Privacy notice</b>”</a
        >.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "AvisoCookies",
  props: {
    idioma: String,
  },
  mounted(){
      this.mostrarFooter = window.localStorage.getItem("showCookiesAdvice") == null ? true : false;
  },
  data() {
    return {
      mostrarFooter: false,
    };
  },
  methods: {
    CerrarFooter() {
      this.mostrarFooter = false;
      window.localStorage.setItem("showCookiesAdvice", false);
    }
  },
};
</script>

<style lang="scss" scoped>
.aviso-cookies {
  background-color: #696158d7;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  align-items: center;
  display: flex;
  justify-content: flex-end;
  position: fixed;
  bottom:10px
}
.aviso-cookies__parrafo {
  padding: 1px 30px 1px 30px;
  font-family: "Poppins";
  color: #ffffff;
  font-size: 14px;
}
.aviso-cookies__contenedor-icono {
    display: flex;
    justify-content: flex-end;
}
.aviso-cookies__icono {
  color: white;
  font-size: 15px;
  margin-right: 15px;
  cursor: pointer;
}
.link-bienvenida {
  font-weight: bold;
  color: #ffffff;
  text-decoration: underline;
}

/* CELULARES */
@media all and (max-width: 767px) {
  .aviso-cookies__parrafo {
    padding: 1px 20px 1px 20px;
    font-size: 11px;
    text-align: center;
  }
  .aviso-cookies__icono {
    color: white;
    font-size: 15px;
    margin-right: 20px;
  }   
  .aviso-cookies__contenedor-icono {
    justify-content: flex-end;
  }
}
</style>
